module.exports = __webpack_public_path__ + "img/1572524552.9ed04f68.jpg";